/**
 * Mapeo de códigos de acción del audit log a etiquetas legibles en español.
 * Usado en la tabla global de auditoría (Admin) y en la caja de log por ficha.
 */

const ACTION_LABELS: Record<string, string> = {
  // Contacto
  contact_created: 'Contacto creado',
  contact_updated: 'Contacto actualizado',
  contact_deleted: 'Contacto eliminado',
  contact_archived: 'Contacto archivado',
  contact_restored: 'Contacto restaurado',
  contact_convert_to_client: 'Contacto convertido a cliente',
  // Usuario
  user_created: 'Usuario creado',
  user_updated: 'Usuario actualizado',
  user_deleted: 'Usuario eliminado',
  user_role_changed: 'Rol de usuario cambiado',
  user_password_reset: 'Contraseña restablecida',
  user_impersonate: 'Suplantación de usuario',
  // Cita
  appointment_created: 'Cita creada',
  appointment_updated: 'Cita actualizada',
  appointment_deleted: 'Cita eliminada',
  appointment_cancelled: 'Cita cancelada',
  // Tarea
  task_created: 'Tarea creada',
  task_updated: 'Tarea actualizada',
  task_deleted: 'Tarea eliminada',
  task_completed: 'Tarea completada',
  // Nota
  note_created: 'Nota creada',
  note_updated: 'Nota actualizada',
  note_deleted: 'Nota eliminada',
  // Oportunidad
  opportunity_created: 'Oportunidad creada',
  opportunity_updated: 'Oportunidad actualizada',
  opportunity_deleted: 'Oportunidad eliminada',
  opportunity_assigned: 'Oportunidad asignada',
  opportunity_stage_changed: 'Etapa de oportunidad cambiada',
  // Contrato
  contract_created: 'Contrato creado',
  contract_updated: 'Contrato actualizado',
  contract_deleted: 'Contrato eliminado',
  contract_signed: 'Contrato firmado',
  contract_status_changed: 'Estado de contrato cambiado',
  // Llamada
  call_created: 'Llamada creada',
  call_updated: 'Llamada actualizada',
  call_deleted: 'Llamada eliminada',
  call_completed: 'Llamada completada',
  // Expediente / delegación
  expediente_created: 'Expediente creado',
  expediente_updated: 'Expediente actualizado',
  delegation_created: 'Delegación creada',
  delegation_updated: 'Delegación actualizada',
};

/**
 * Devuelve la etiqueta legible para un código de acción.
 * Si no existe mapeo, devuelve el valor formateado (snake_case → título).
 */
export function getActivityActionLabel(action: string): string {
  if (!action) return '';
  const label = ACTION_LABELS[action];
  if (label) return label;
  // Fallback: convertir snake_case a "Palabras Con Mayúscula"
  return action
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
